<template>
  <div class="act">
    <div class="bg"></div>
    <div class="videoWrap">
      <div class="videoBg">
        <div id="player"></div>
        <div class="lt"><img src="../assets/act/student@2x.png" alt=""> </div>
        <div class="rt"><img src="../assets/act/bag@2x.png" alt=""> </div>
      </div>
    </div>
    <div class="one actImg"><img v-lazy="require('../assets/act/1@2x.png')" alt=""></div>
    <div class="actImg"><img v-lazy="require('../assets/act/2@2x.png')" alt=""></div>
    <div class="actImg"><img v-lazy="require('../assets/act/3@2x.png')" alt=""></div>
    <div class="btn" @click="btn"></div>
    <van-popup v-model="boxShow" round closeable close-icon-position="top-right">
      <div class="box">
        <div class="title"><p>请填写真实信息，以便老师跟踪指导</p><p>如信息错误，将会影响您的正常使用</p></div>
          <div class="contain">
            <input
              class="phone"
              v-model="phoneValue"
              type="number"
              placeholder="请输入手机号码"
              maxlength="11"
              id="phoneInput"
            />
            <input
              class="name"
              v-model="nameValue"
              type="text"
              placeholder="请输入真实学生姓名"
              id="nameInput"
            />
          </div>
          <div class="ling" @click="goBuy()">立即领取</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
var player = null;
export default {
name: 'home',
data() {
  return {
    pid: '',
    aid: '',
    school_id: '',
    pl_id:'d15b750dc14ca71476bcd13f6ce83c9c_d',
    token:'',
    boxShow: false,// 领取面板
    phoneValue: '',// 手机号
    nameValue: '',// 名字
  }
},
created() {
  this.pid = this.$route.query.pid;
  this.aid = this.$route.query.aid;
  this.school_id = this.$route.query.school_id;

  this.playVideo()
},
methods: {
  //获取保利视频的相关信息
  async getPolyvInfo(){
    const res = await this.$get('mobile/video', { pl_id: this.pl_id })
    if (res.code === 0) { return res.data }
    return false;
  },
  //点击课程试听进行视频播放
  async playVideo() {
    const pl_obj = await this.getPolyvInfo()
    // eslint-disable-next-line no-undef
    player = polyvPlayer({
      wrap: '#player',
      width:"100%",
      height: "100%",
      "vid": pl_obj.pl_id,
      playsafe: pl_obj.ployvToken,
      ts: pl_obj.ts,//保利的ts
      sign: pl_obj.sign,//保利的sign
      'forceH5': true,
      skinLocation:1,//默认是1
      // autoplay:true,
      screenshot:true,//开启视频截图
      // skinLocation:0
      preview: false, // 是否使用预览模式，到达预览时长后会停止播放
    });
  },
  // 免费领取
  btn() {
    this.boxShow = true
  },
  // 获取 csrf_token
  async getCsrf_token(){
    let url = "token/csrf"
    const {data: res} = await this.$get(url)
    return res.csrf_token;
  },
  // 确认领取按钮
  async goBuy() {
    const regMobile = /^1[0-9]{10}$/ 
    if (!regMobile.test(this.phoneValue)) {
      this.$Toast.fail('请输入正确的手机号')
      return;
    }
    const regName = /^[\u4E00-\u9FA5]{2,10}$/;
    if(!regName.test(this.nameValue)){
      this.$Toast.fail('请输入正确的姓名')
      return;
    }
    const csrf_token = await this.getCsrf_token()
    const res = await this.$post('/mobile/user/receive', {
      csrf_token,
      aid: this.aid,
      pid: this.pid,
      school_id: this.school_id,
      username: this.nameValue,
      phone: this.phoneValue
    })
    console.log(res)
    if(res.code === 0) {
      this.$router.push({path: '/success', query: {phone: this.phoneValue, new: res.data.new}})
    }else if(res.code === 50004){
      this.$Toast.fail(res.msg)
      this.$router.push({path: '/success', query: {phone: this.phoneValue, new: false}})
    }else {
      this.$Toast.fail(res.msg)
    }
  }
},
}
</script>
<style lang="scss">
  .act{
    background: #FF7C19;
    width: 100%;
    min-height: 100vh;
    overflow: hidden;
    padding-bottom: 3.5rem;
    box-sizing: border-box;
    position: relative;
    font-family: PingFangSC-Regular, PingFang SC;
    .bg {
      width: 100%;
      height: 29.1rem;
      background: url(../assets/act/bg.png) no-repeat;
      background-size: 100%;
    }
    .videoWrap {
      width: 100%;
      position: absolute;
      top: 1.75rem;
      z-index: 2;
      .videoBg {
        margin: 0 auto;
        width: 18.2rem;
        height: 12.25rem;
        background: url(../assets/act/tv@2x.png) no-repeat;
        background-size: 100%;
        padding-top: .6rem;
        position: relative;
        #player{
          margin: 0 auto;
          width: 90% !important;
          height: 9.65rem !important;
          border-radius: .5rem;
          overflow: hidden;
        }
        .lt, .rt {
          position: absolute;
          bottom: 0;
          z-index: 9999;
        }
        .lt {
          left: -.4rem;
          img {
            width: 3.45rem;
            height: 3.3rem;
          }
        }
        .rt {
          right: -.4rem;
          img {
            width: 2.3rem;
            height: 2.95rem;
          }
        }
      }
    }
    .one {
      margin-top: -14rem;
    }
    .actImg {
      padding: 0 .8rem;
      box-sizing: border-box;
      img {
        width: 100%;
      }
    }
    .btn {
      position: fixed;
      bottom: .5rem;
      left: 50%;
      transform: translateX(-50%);
      width: 17.15rem;
      height: 2.7rem;
      background: url(../assets/act/btn@2x.png) no-repeat;
      background-size: 100%;
    }
    .box {
      width: 17.15rem;
      height: 14.65rem;
      background: #FFF;
      padding: 1.1rem 2.1rem 0;
      box-sizing: border-box;
      font-size: .8rem;
      color: #333;
      font-weight: 600;
      .title {
        margin: 1rem auto 1.1rem;
        p {
          margin: 0;
          margin-bottom: .12rem;
        }
      }
      .contain {
        input {
          font-weight: 500;
          font-size: .65rem;
          color: #BCBCBC;
          width: 100%;
          height: 2rem;
          border-radius: 0.3rem;
          border: 1px solid #d6d7d8;
          position: relative;
          margin-bottom: 0.8rem;
          padding-left: 0.5rem;
          box-sizing: border-box;
          font-size: 0.48rem;
        }
        
      }
      .ling {
        margin-top: .2rem;
        width: 100%;
        height: 2rem;
        font-weight: 500;
        background: linear-gradient(90deg, #FFB336 0%, #FF7C19 100%);
        border-radius: .2rem;
        text-align: center;
        line-height: 2rem;
        color: #fff;
        font-size: .7rem;
      }
    }
  }
</style>
